import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EmailService } from '../../services/email.service';
import { AuthService } from '../../services/auth.service';
import { UpdateUser } from 'src/app/model/UpdateUser.model';

@Component({
  selector: 'app-edit-pass-word',
  templateUrl: './edit-pass-word.component.html',
  styleUrls: ['./edit-pass-word.component.css'],
})
export class EditPassWordComponent implements OnInit {
  userEmail!: string;

  titleCard: string = 'Pour se connecter';
  userForm!: FormGroup;
  isValid: boolean = false;
  passwordSecond: string = '';
  passwordFirst: string = '';
  passwordError: string | null = null;
  userData: any;

  constructor(
    private formBuilder: FormBuilder,
    private emailService: EmailService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.userForm = this.formBuilder.group({
      passwordFirst: ['', Validators.required],
      passwordSecond: ['', Validators.required],
    });
    this.userEmail = this.emailService.getEmail();

    this.authService.getUserByEmail(this.userEmail).subscribe((Response) => {
      //// //console.log(Response[0]);
      this.userData = Response[0];
    });

    this.titleCard = 'Pour se connecter';
  }

  onSubmit() {
    const formValue = this.userForm.value;

    const updatePassword = new UpdateUser(
      this.userData.userName,
      this.userData.email,
      formValue['passwordFirst'],
      this.userData.firstName,
      this.userData.lastName
    );

    //// //console.log(updatePassword);
    // //// //console.log(this.userEmail);

    //// //console.log(this.userData.id);
    this.authService
      .updatePassword(this.userData.id, updatePassword)
      .subscribe((Response) => {
        //// //console.log('La reponse:{}' + Response);
      });
  }

  validatePasswords() {
    this.passwordError = null;

    if (this.passwordFirst.length < 8) {
      this.passwordError = 'Le mot de passe doit avoir au moins 8 caractères.';
    } else if (this.passwordFirst !== this.passwordSecond) {
      this.passwordError = 'Les mots de passe ne correspondent pas.';
    }
  }

  passwordsMatch(): boolean {
    return (
      this.passwordFirst === this.passwordSecond && this.passwordError === null
    );
  }
}
